import type { ProductCardD2CBadge } from "../../blocks/product-card-d2c/product-card-d2c";

export type BadgeTexts = {
  new?: string;
  sale?: string;
};

type Product = {
  isNewOnB2C?: boolean;
  discountString?: string;
};

const DEFAULT_SALE_BADGE_LABEL = "Sale";

export function buildBadges(
  product: Product,
  variantProducts: Product[],
  texts: BadgeTexts
): ProductCardD2CBadge[] {
  const badges: ProductCardD2CBadge[] = [];

  const hasSaleData = (input: Product): boolean => {
    const discount = input.discountString?.trim();

    return Boolean(discount);
  };

  const isNew =
    product.isNewOnB2C || variantProducts.some((variant) => variant.isNewOnB2C);
  const hasSale = hasSaleData(product) || variantProducts.some(hasSaleData);

  if (hasSale) {
    badges.push({
      text: texts.sale ?? DEFAULT_SALE_BADGE_LABEL,
      variant: "sale",
    });
  }

  if (isNew && texts.new) {
    badges.push({ text: texts.new, variant: "sale" });
  }

  return badges;
}
